module.exports = __webpack_public_path__ + "static/media/postage-shipping.6888af86.svg";